import React, { PropTypes } from 'react'
import { connect } from 'react-redux';
import CurrentWebinarsView from 'components/Dashboard/CurrentWebinars/CurrentWebinars';
import CurrentWebinarItem from 'components/Dashboard/CurrentWebinars/CurrentWebinarItem';
import actions from 'actions';
import constants from 'constants';

const {
  subscribeWebinarSaga,
  joinWebinarSaga
} = actions;

const {
  CURRENT_WEBINARS
} = constants;

class CurrentWebinars extends React.Component {
  constructor(props) {
    super(props);
  }

  webinars = () => (
    this.props.webinars.map(webinar => {
      return(
        <CurrentWebinarItem
          key={webinar.id}
          webinar={webinar}
          userRole={this.props.userRole}
          subscriptionAction={() => this.subscriptionAction(webinar)}
        />
      )
    })
  )

  subscriptionAction = (webinar) => {
    if (webinar.joined) {
      window.open(webinar.users_join_url, '_blank')
    } else {
      window.webinarTab = window.open()
      window.webinarTab.document.write('Loading webinar...')
      this.props.joinWebinar(webinar.id);
    }
  }

  render() {
    return(
      <CurrentWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    )
  }
}

CurrentWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
}

const mapStateToProps = (state) => ({
  pages: state.webinars[CURRENT_WEBINARS].pages,
  userRole: state.users.user.user_type
})

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar)),
  joinWebinar: (webinarId) => dispatch(joinWebinarSaga(webinarId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentWebinars);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/CurrentWebinars/CurrentWebinars.jsx
 **/